import styles from "./Features.module.css";
import { Skeleton, SpeedDial } from "@mui/material";
import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";
import { useSnackbar } from "notistack";

// React
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

// Tools
import Services from "tools/Services";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// Components
import FeatureItem from "./FeatureItem/FeatureItem";
import Filters from "./Filters";
import Loader from "components/Loader";
import FeatureSkeleton from "./FeatureSkeleton";

export default function Features() {
	const { role } = useContext(MyContext);
	const { enqueueSnackbar } = useSnackbar();
	const [loading, setLoading] = useState(true);

	const [allFeatures, setAllFeatures] = useState([]);
	const [filteredFeatures, setFilteredFeatures] = useState([]);

	useEffect(() => {
		loadFeatures();
	}, []);

	const loadFeatures = async () => {
		// GET
		let res = await Services.get("/Feature/getFeatures");

		// ERROR
		if (res.status !== 200) {
			return;
		}

		// SUCCES
		setAllFeatures(res.data);
		setLoading(false);
	};

	// handles
	const handleChangeUpdateFeature = async (updatedFeature) => {
		// PUT
		let res = await Services.put("/Feature", updatedFeature);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setAllFeatures(
			allFeatures.map((feature) => {
				if (feature.idFeature === updatedFeature.idFeature) {
					return updatedFeature;
				}
				return feature;
			})
		);
	};
	const handleChangeState = (updatedFeature) => {
		setAllFeatures(
			allFeatures.map((feature) => {
				if (feature.idFeature === updatedFeature.idFeature) {
					return updatedFeature;
				}
				return feature;
			})
		);
	};

	const handleDeleteFeature = async (id) => {
		// DELETE
		let res = await Services.delete("/Feature/" + id);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setAllFeatures(allFeatures.filter((feature) => feature.idFeature !== id));
		enqueueSnackbar("Deleted", {
			variant: "success",
		});
	};

	const onChangeFilters = (features) => {
		setFilteredFeatures(features);
	};

	return (
		<>
			{/* {loading && <Loader />}  */}
			{/* {loading && <Skeleton />} */}
			<>
				<Filters
					features={allFeatures}
					onChange={onChangeFilters}
					filteredFeaturesLength={filteredFeatures.length}
				/>

				{loading ? (
					<div className={styles.content}>
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
						<FeatureSkeleton />
					</div>
				) : (
					<div className={styles.content}>
						{filteredFeatures
							.filter((f) => f.status !== 2, 3, 4)
							.map((feature) => (
								<FeatureItem
									key={feature.idFeature}
									feature={feature}
									onChange={handleChangeUpdateFeature}
									onChangeState={handleChangeState}
									onClickDelete={handleDeleteFeature}
								/>
							))}
					</div>
				)}
			</>

			{role === Role.Admin && (
				<NavLink to={{ pathname: "/features/new" }}>
					<SpeedDial
						ariaLabel="SpeedDial"
						sx={{ position: "fixed", bottom: 40, right: 16 }}
						icon={<Icon path={mdiPlus} size={1} />}
					></SpeedDial>
				</NavLink>
			)}
		</>
	);
}
